import { render } from "./ItOpsJourney.vue?vue&type=template&id=6ccbff9e"
import script from "./ItOpsJourney.vue?vue&type=script&lang=js"
export * from "./ItOpsJourney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__